import { render } from "./Alifiados.vue?vue&type=template&id=0698d6e8"
import script from "./Alifiados.vue?vue&type=script&lang=js"
export * from "./Alifiados.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__